import { TRecursiveNonNullable } from '@api/Helper.types';
import {
    GetDocumentUploadResponse,
    fetchGetDocumentUpload
} from '@iwoca/lapi-client/edge';
import { useQuery } from '@tanstack/react-query';

type TGetDocumentUploadResponse =
    TRecursiveNonNullable<GetDocumentUploadResponse>;

export function useGetDocuments(stateKey: string) {
    const { data } = useQuery<GetDocumentUploadResponse>({
        queryKey: ['documents', stateKey],
        queryFn: () => fetchGetDocumentUpload({ stateKey }),
        enabled: !!stateKey
    });

    return {
        data: data as TGetDocumentUploadResponse
    };
}
